
<div class="contentWrapper">
    <div class="logo">
        <div class="Wrapper">
            <!-- <span>flowtrics</span> -->
            <a [routerLink]="'/'"><img src="../../../assets/images/logo/flowtrics_logo.png" alt=""></a>
        </div> 
    </div>   
    
    <div class="Wrapper">
        <h3>This document has been assigned to another individual for signature. Thank you for your participation.</h3>        
        <div class="emailImg">
            <img src="../../../assets/images/thanksEmail.png" alt="">
        </div>      
    </div> 
</div>


